import { render, staticRenderFns } from "./Switch.vue?vue&type=template&id=1c8496bc&scoped=true&"
import script from "./Switch.vue?vue&type=script&lang=js&"
export * from "./Switch.vue?vue&type=script&lang=js&"
import style0 from "./Switch.vue?vue&type=style&index=0&id=1c8496bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8496bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/dilan/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c8496bc')) {
      api.createRecord('1c8496bc', component.options)
    } else {
      api.reload('1c8496bc', component.options)
    }
    module.hot.accept("./Switch.vue?vue&type=template&id=1c8496bc&scoped=true&", function () {
      api.rerender('1c8496bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PUI/Controls/Switch.vue"
export default component.exports